import m from "../../geodata/es2015/eswatiniHigh";
window.am4geodata_eswatiniHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/eswatiniHigh.js
// module id = null
// module chunks = 